import { render, staticRenderFns } from "./RowFileIcon.vue?vue&type=template&id=6fdc54fe"
import script from "./RowFileIcon.vue?vue&type=script&lang=js"
export * from "./RowFileIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports